import { useSelector } from '../../../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../../../app.store';
import {
  type BoundaryAdvancedEditActiveState,
  type BoundaryPolygonEditActiveState,
  isBoundaryAdvancedEditActive,
  isBoundaryAdvancedEditModalOpen,
  isBoundaryDrawActive,
  isBoundaryPolygonEditActive,
  isBoundaryPolygonEditModalOpen,
} from './boundaryDraw.state';

export const boundaryDrawSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryDraw;

const boundaryPolygonEditActiveSelector = (state: AppState): BoundaryPolygonEditActiveState | null => {
  const { boundaryDraw } = state.frontendState.mapTools.boundary;
  return isBoundaryPolygonEditActive(boundaryDraw) ? boundaryDraw : null;
};
export const useBoundaryPolygonEditActiveSelector = () => useSelector(boundaryPolygonEditActiveSelector);

const boundaryPolygonEditModalOpenSelector = (state: AppState): BoundaryPolygonEditActiveState | null => {
  const { boundaryDraw } = state.frontendState.mapTools.boundary;
  return isBoundaryPolygonEditModalOpen(boundaryDraw) ? boundaryDraw : null;
};
export const useBoundaryPolygonEditModalOpenSelector = () => useSelector(boundaryPolygonEditModalOpenSelector);

const boundaryAdvancedEditActiveSelector = (state: AppState): BoundaryAdvancedEditActiveState | null => {
  const { boundaryDraw } = state.frontendState.mapTools.boundary;
  return isBoundaryAdvancedEditActive(boundaryDraw) ? boundaryDraw : null;
};
export const useBoundaryAdvancedEditActiveSelector = () => useSelector(boundaryAdvancedEditActiveSelector);

const boundaryAdvancedModalOpenSelector = (state: AppState): BoundaryAdvancedEditActiveState | null => {
  const { boundaryDraw } = state.frontendState.mapTools.boundary;
  return isBoundaryAdvancedEditModalOpen(boundaryDraw) ? boundaryDraw : null;
};
export const useBoundaryAdvancedEditModalOpenSelector = () => useSelector(boundaryAdvancedModalOpenSelector);

const boundaryDrawActiveSelector = (state: AppState) => {
  const { boundaryDraw } = state.frontendState.mapTools.boundary;
  return isBoundaryDrawActive(boundaryDraw) ? boundaryDraw : null;
};
export const useBoundaryDrawActiveSelector = () => useSelector(boundaryDrawActiveSelector);
export const useBoundaryDrawDragActiveSelector = () => useSelector(boundaryDrawActiveSelector)?.drawType === 'Drag';
